import {Component, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import { ActivatedRoute } from '@angular/router';
import {NGXLogger} from "ngx-logger";
import {User} from "../modele/user/userModel";
@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

    private log_prefix = this.constructor.name;
    constructor(private route: ActivatedRoute, private api: ApiService, private logger: NGXLogger) {

    }

    products;
    user:User;

    ngOnInit() {
        // this.api.getProducts().subscribe(products => {
        //     this.products = products
        // });
        // this.api.getUser().subscribe(user => {
        //     this.logger.info(this.log_prefix,"1ng on init:","have user:",user);
        //     this.users = user
        // });
        this.logger.info(this.log_prefix,"2ng on init:",Object.keys(this.route.snapshot.data));
        this.logger.info(this.log_prefix,"3ng on init:",this.route.snapshot.data?.user);
        this.user = this.route.snapshot.data.user;
        // this.products = this.route.snapshot.data.products;
        // this.user = this.route.snapshot.data.user;
        this.logger.info(this.log_prefix,"have user object:",Object.keys(this.user));
    }


}
